export const data = [
  { id: 1, todo: "Hello" },
  { id: 2, todo: "New" },
  { id: 3, todo: "Cool" },
];
